import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Slider,
  Button,
  Box
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useState } from "react";
import { SkillTypeBlock } from "../../../Common/SkillTypeBlock";

const SkillRow = ({ skill, skill_types, proficiency, projectedLevel, description, pendingValidationRequest, editSkillLevel, hasUpdates, setHasUpdates, createValidationRequest }) => {
  const proficiencyLevel = {undefined: "Unvalidated", 0:"Unvalidated", 1:"beginner", 2:"proficient", 3:"experienced", 4:"expert"}
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        <Accordion
          style={{
            padding: "0",
            boxShadow: "none",
          }}
        >
          <AccordionSummary
            aria-controls="panel1a-content"
            id="panel2a-header"
            style={{ padding: "0" }}
          >
            <SkillTypeBlock skill_types={skill_types}/>
            <Typography style={{ borderBottom: "1px dashed #000" }}>
              {skill}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ padding: "0" }}>
            {description}
          </AccordionDetails>
        </Accordion>
      </TableCell>
      <TableCell align="left" style={{width:"50%"}}>
        {"User Expertise Level: " + proficiencyLevel[proficiency]}
        <Slider
          value={proficiency}
          aria-labelledby="discrete-slider"
          /*valueLabelDisplay="auto"*/
          step={1}
          marks
          min={0}
          sx={{
            color: "#53D28E",
            height: 10,
            mr: 1.25,
            '& .MuiSlider-thumb': { height: 14, width: 14, backgroundColor: "#fff", border: "3px solid currentColor",  ml: 0, '&:focus, &:hover, &.Mui-active': { boxShadow: "inherit" } },
            '& .MuiSlider-track': { height: 10, borderRadius: 10, pr: 1.5 },
            '& .MuiSlider-rail': { height: 10, borderRadius: 10, pr: 1.5, backgroundColor: "#dedede" },
            '& .MuiSlider-mark': { backgroundColor: "#DDE0E5", height: 4, width: 4, borderRadius: 4, ml: 0.5 },
            '& .MuiSlider-markActive': { backgroundColor: "#53D28E" },
          }}
          max={4}
        />
        {"Your Expertise Evaluation Level: " + proficiencyLevel[projectedLevel]}
        <Slider
          value={projectedLevel ? projectedLevel : 0}
          aria-labelledby="discrete-slider"
          step={1}
          marks
          min={0}
          sx={{
            color: "#FF6A14",
            height: 10,
            mr: 1.25,
            '& .MuiSlider-thumb': { height: 14, width: 14, backgroundColor: "#fff", border: "3px solid currentColor", ml: 0, '&:focus, &:hover, &.Mui-active': { boxShadow: "inherit" } },
            '& .MuiSlider-track': { height: 10, borderRadius: 10, pr: 1.5 },
            '& .MuiSlider-rail': { height: 10, borderRadius: 10, pr: 1.5, backgroundColor: "#dedede" },
            '& .MuiSlider-mark': { backgroundColor: "#DDE0E5", height: 4, width: 4, borderRadius: 4, ml: 0.5 },
            '& .MuiSlider-markActive': { backgroundColor: "#FF6A14" },
          }}
          onChange={(event, newValue) => {
            editSkillLevel(skill, newValue)
            setHasUpdates([...hasUpdates, skill]);
          }}
          max={4}
        />
      </TableCell>
      <TableCell>
        <Button variant="contained" disabled={pendingValidationRequest} color="primary" size="small" onClick={() => createValidationRequest(skill)}>
          Request Validation
        </Button>
      </TableCell>
    </TableRow>
  );
};

const SkillProficiencyTable = ({ skills, editSkillLevel, hasUpdates, setHasUpdates, createValidationRequest }) => (
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>Skill</TableCell>
        <TableCell  style={{width:"40%"}} align="right">Expertise</TableCell>
        <TableCell  style={{width:"10%"}} align="right"></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {skills.map((skill) => (
        <SkillRow key={"_" + skill.skill} {...skill} editSkillLevel={editSkillLevel} hasUpdates={hasUpdates} setHasUpdates={setHasUpdates} createValidationRequest={createValidationRequest}/>
      ))}
    </TableBody>
  </Table>
);

const SkillsExpansionPanel = ({ job, defaultExpanded, editSkillLevel, hasUpdates, setHasUpdates, saveSkills, createValidationRequest }) => {
  const [isExpanded, toggleExpansion] = useState(false);
  const [subPannelExpanded, setSubPanelExpanded] = useState("skill");

  useEffect(() => {
    toggleExpansion(defaultExpanded);
  }, [defaultExpanded]);

  return (
    <Accordion
      expanded={isExpanded}
      onChange={(_, isExpanded) => toggleExpansion(isExpanded)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        {
          ((job.title.includes("Manually Added") || job.title.includes("Resource Added Skills")) ? (
            <Typography>{job.title}</Typography>
          ) : (
            <Typography>Skill Summary for {job.title}</Typography>
          )
          )}
        {hasUpdates && hasUpdates.length > 0 && (
          <Box sx={{width:"100%", display:"flex", flexDirection:"row-reverse"}}>
            <Button
                variant="contained" 
                color="primary" 
                onClick={(event) => {
                  event.stopPropagation()
                  saveSkills(hasUpdates);
                  setHasUpdates([])
                }}
              > Save Changes </Button>
          </Box>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <div>
        <Accordion
          expanded={subPannelExpanded === "skill" ? true : false}
          onChange={(_, isExpanded) => subPannelExpanded === "skill" ? setSubPanelExpanded("") : setSubPanelExpanded("skill")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Skills</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <SkillProficiencyTable skills={job.skills} editSkillLevel={editSkillLevel} hasUpdates={hasUpdates} setHasUpdates={setHasUpdates} createValidationRequest={createValidationRequest}/>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={subPannelExpanded === "optional" ? true : false}
          onChange={(_, isExpanded) => subPannelExpanded === "optional" ? setSubPanelExpanded("") : setSubPanelExpanded("optional")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Optional Skills</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <SkillProficiencyTable skills={job.optionalSkills} editSkillLevel={editSkillLevel} hasUpdates={hasUpdates} setHasUpdates={setHasUpdates} createValidationRequest={createValidationRequest}/>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={subPannelExpanded === "deleted" ? true : false}
          onChange={(_, isExpanded) => subPannelExpanded === "deleted" ? setSubPanelExpanded("") : setSubPanelExpanded("deleted")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Removed Skills</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <SkillProficiencyTable skills={job.deletedSkills} editSkillLevel={editSkillLevel} hasUpdates={hasUpdates} setHasUpdates={setHasUpdates} createValidationRequest={createValidationRequest}/>
          </AccordionDetails>
        </Accordion>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export const SkillsBackpackSummary = ({
  skillsInfo,
  isOnPrintMode,
  groupSkillsBackpack,
  editSkillLevel,
  saveSkills,
  createValidationRequest
}) => {
  const [hasUpdates, setHasUpdates] = useState([]);

  if (!skillsInfo) {
    return null;
  }
  if (groupSkillsBackpack) {
    return (
      <Box sx={{ pl: "1em" }}>
        {skillsInfo.map((backpack) => {
          const proficientLevels = Array.from(
            new Set(backpack.skills.map((skill) => skill.proficiency))
          );
          const groupedSkills = proficientLevels.reduce(
            (acl, curr) =>
              Object.assign({}, acl, {
                [curr]: backpack.skills
                  .filter((skill) => skill.proficiency === curr)
                  .map((a) => a.skill),
              }),
            {}
          );
          return (
            <>
              <p>
                Skills Backpack for <b>{backpack.title}</b>
              </p>
              {Object.keys(groupedSkills).map((proficiency) => (
                <p key={proficiency}>
                  {proficiency} in: {groupedSkills[proficiency].join(", ")}
                </p>
              ))}
            </>
          );
        })}
      </Box>
    );
  }
  return (
    <>
      {skillsInfo.map((job, i) => (
        <SkillsExpansionPanel
          job={job}
          key={job.title + "_" + i}
          defaultExpanded={isOnPrintMode}
          editSkillLevel={editSkillLevel}
          setHasUpdates={setHasUpdates}
          hasUpdates={hasUpdates}
          saveSkills={saveSkills}
          createValidationRequest={createValidationRequest}
        />
      ))}
    </>
  );
};
